module.exports = __webpack_public_path__ + "img/f_25_04.0044a419.jpg";